export const pxToEm = (px: number) => {
  return `${px / 16}em`
}
